import security from '../../service/security/security-services';
export default class sideMenuAdminController {

    private activeTab: string;
    private showHomeMenuItem = false;
    private showUsersMenuItem = false;
    private showGroupsMenuItem = false;

    constructor(security: security, $route: angular.route.IRouteService) {
        const vm = this;

        this.activeTab = ($route.current as any).activeTab;

        security.ensureCurrentUser()
            .then( user => {
                vm.showHomeMenuItem = user.hasPermissionInAnyScope('UI_ADMIN_HOME_PANE', 'VIEW');
                vm.showUsersMenuItem = user.hasPermissionInAnyScope('UI_ADMIN_USER_PANE','VIEW');
                vm.showGroupsMenuItem = user.hasPermissionInAnyScope('UI_CONTRACTGROUP_ADMIN', 'VIEW');
            });
    }
}
sideMenuAdminController.$inject = ['security', '$route'];
